// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__22dEB","Layout_wrapper":"Layout_Layout_wrapper__3_Z4A"};